import { AuthContextProvider } from './auth'
import Router from './Router'
import { ConfigProvider, App as AntApp } from 'antd'
import enUS from 'antd/locale/en_US'
import viVN from 'antd/locale/vi_VN'
import zhCN from 'antd/locale/zh_CN'
import zhTW from 'antd/locale/zh_TW'
import { I18nProvider, useI18n } from './i18n/I18nProvider'

const theme = {
  token: {
    // Primary CTA color: TTI Blue (per Figma color balance — 10% brand allocation).
    // Used for primary buttons like Export PDF. TTI Grey remains the brand text color.
    colorPrimary: '#0080C1',
    colorInfo: '#0080C1',     // TTI Blue
    colorInfoBg: '#E6F2F9',   // TTI Blue Light — info alert background
    colorInfoBorder: '#0080C1', // TTI Blue — info alert border
    colorSuccess: '#33754B',  // Antd-aligned semantic green
    colorWarning: '#FA8C16',  // Antd-aligned semantic orange
    colorError: '#D3222A',    // TTI Red
    colorLink: '#0080C1',     // TTI Blue for links (was TTI Grey)
    colorTextLightSolid: '#FFFFFF', // White text on TTI Blue backgrounds (Export PDF button, notification badge)
    colorTextDescription: '#475254', // TTI Grey for descriptive text
    borderRadius: 4,
    colorBgContainer: '#FFFFFF',
    colorBgLayout: '#FAFAFA',
    colorText: '#475254',     // TTI Grey — body text per Figma
    colorTextSecondary: '#475254',
    fontFamily: "'trade-gothic-next', 'Barlow', 'Helvetica Neue', Arial, sans-serif",
  },
  components: {
    Table: {
      headerBorderRadius: 0,
    },
    Tabs: {
      horizontalItemGutter: 0,
      horizontalGutter: 0,
      horizontalMargin: 0,
    },
    Button: {
      colorPrimary: '#0080C1',  // TTI Blue primary CTA background
      defaultBg: '#FFFFFF',
      defaultColor: '#475254',
      defaultBorderColor: '#B9BFC0',
    },
    Layout: {
      headerBg: '#FFFFFF',
      bodyBg: '#F2F2F2',  // Neutral Grey 1 (TTI Design System) — closest match to #F4F4F4
      siderBg: '#FFFFFF',
    },
    Checkbox: {
      // Figma Checkbox (1189:29392): 20px square with a TTI Light Grey border.
      controlInteractiveSize: 20,
      borderRadiusSM: 0,
      colorBorder: '#A3AEAC',
      colorBgContainer: '#FFFFFF',
    },
    Card: {
      colorBorderSecondary: '#E5E5E5',  // Neutral Grey 2 — subtle card border
      headerBg: '#475254',              // TTI Grey header bar
      headerFontSize: 16,
      colorTextHeading: '#FFFFFF',      // White title text on the grey header bar
      paddingLG: 24,
    },
  },
}

const antdLocales = {
  en: enUS,
  vi: viVN,
  'zh-Hans': zhCN,
  'zh-Hant': zhTW,
}

function AppShell() {
  const { locale } = useI18n()
  const antdLocale = antdLocales[locale] || enUS

  return (
    <ConfigProvider theme={theme} locale={antdLocale}>
      <AntApp>
        <AuthContextProvider>
          <Router />
        </AuthContextProvider>
      </AntApp>
    </ConfigProvider>
  )
}

function App() {
  return (
    <I18nProvider>
      <AppShell />
    </I18nProvider>
  )
}

export default App
